import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpdateSkills = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 22,
	height: 19,
	viewBox: "0 0 619.000000 552.000000",
	preserveAspectRatio: "xMidYMid meet",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0.000000,552.000000) scale(0.100000,-0.100000)",
		fill: "#000000",
		stroke: "none",
		children: /* @__PURE__ */ _jsx("path", { d: "M2842 5509 c-283 -49 -522 -262 -602 -539 -18 -61 -23 -110 -27 -262 l-5 -187 -687 -4 c-767 -3 -728 0 -886 -77 -193 -95 -336 -266 -397 -475 l-23 -80 0 -1620 0 -1620 23 -79 c40 -137 94 -229 197 -331 102 -102 167 -144 292 -189 l88 -31 2450 -3 c2683 -3 2510 -6 2658 54 71 28 180 100 230 151 l37 39 -2 2014 -3 2014 -70 59 c-74 62 -191 124 -290 153 -54 16 -126 18 -746 21 l-687 4 -5 187 c-6 211 -16 261 -77 387 -75 151 -196 273 -345 345 -152 73 -149 73 -635 76 -239 1 -459 -2 -488 -7z m906 -534 c59 -32 103 -87 121 -150 6 -22 11 -100 11 -172 l0 -133 -581 0 -581 0 4 153 c3 147 4 154 33 205 31 57 87 103 146 121 21 6 183 9 414 8 l380 -2 53 -30z m2000 -1000 c59 -32 103 -87 121 -150 7 -27 11 -197 11 -507 l0 -468 -910 0 -910 0 -2 168 -3 167 -755 0 -755 0 -3 -167 -2 -168 -911 0 -910 0 3 488 3 487 30 53 c31 57 87 104 146 120 22 7 870 10 2414 9 l2380 -2 53 -30z m-3208 -1800 l0 -165 760 0 760 0 0 165 0 165 910 0 910 0 0 -798 c0 -879 1 -860 -62 -936 -17 -21 -54 -49 -82 -62 l-51 -24 -2385 0 -2385 0 -50 24 c-28 12 -65 39 -82 59 -64 73 -63 57 -63 939 l0 798 910 0 910 0 0 -165z" })
	})]
});
const ForwardRef = forwardRef(SvgUpdateSkills);
export { ForwardRef as ReactComponent };
